<template>
	<div class="page-account">
					<div class="page-account-container">
						<div class="page-account-top">
							<div class="page-account-top-title">注册</div>
						</div>
						<i-form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
							<form-item label="手机号" prop="phone">
								<row :wrap="false">
									<i-col flex="auto" style="margin-right:10px">
										<i-input v-model="formValidate.phone" size="large" placeholder="请输入手机号"></i-input>
									</i-col>
									<i-col flex="none">
										<div>
											<i-button class="phoneCode" v-show="show" size="large" type="info"
												@click="getCode">获取验证码
											</i-button>
											<i-button class="phoneCode" v-show="!show" size="large" type="info"
												@click="getCode">
												{{count}}s
											</i-button>
										</div>
									</i-col>
								</row>
							</form-item>
							<form-item label="验证码" prop="code">
								<i-input v-model="formValidate.code" size="large" placeholder="请输入验证码"></i-input>
							</form-item>
							<form-item label="密码" prop="password">
								<i-input v-model="formValidate.password" size="large" placeholder="请输入密码"></i-input>
							</form-item>
							<form-item label="确认密码" prop="confirmPwd">
								<i-input v-model="formValidate.confirmPwd" size="large" placeholder="请再次确认密码"></i-input>
							</form-item>
							<form-item :label-width="0">
								<div class="login_btn-wrapper">
									<i-button class="login_btn" long size="large" @click="handleSubmit('formValidate')">提交
									</i-button>
								</div>
							</form-item>
						</i-form>
					</div>
				</div>

</template>

<script>
	export default {
		data(){
			return {
				show: true,
				count: 0,
				timer: null,
				formValidate: {
					phone: '',
					code: '',
					password: '',
					confirmPwd: '',
				},
				ruleValidate: {
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						{
							pattern: /^1[3456789]\d{9}$/,
							message: "手机号码格式不正确",
							trigger: "blur"
						}
					],
					code: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					confirmPwd: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
				}
			}
						},
						methods: {
							/**
							 * 获取手机验证码
							 */
							getCode() {
								if (this.formValidate.phone != '') { // 1.首先判断是否未输入手机号码就点击获取验证码
									if (/^1[34578]\d{9}$/.test(this.formValidate.phone)) { //2.使用正则判断手机输入的验证码是否符合规范
										const TIME_COUNT = 60; // 3.设置时间为60s
										if (!this.timer) {
											this.count = TIME_COUNT;
											this.show = false; // 4.隐藏获取验证码按钮,展示倒计时模块
											this.getPhoneCode() // 5.调用后端获取验证码接口的函数
											this.timer = setInterval(() => {
												if (this.count > 0 && this.count <= TIME_COUNT) { // 6.设置每秒钟递减
													this.count--;
												} else { // 7.递减至0时,显示获取验证码按钮,隐藏倒计时模块,清除定时器this.timer,并将其置为null
													this.show = true;
													clearInterval(this.timer);
													this.timer = null;
												}
											}, 1000)
										}
									} else {
										this.$Message.error('手机号格式不正确!');
									}
								} else {
									this.$Message.error('请先填写手机号码!');
								}
							},
							getPhoneCode() {
								let phoneParam = {
									phone: this.phoneFormItem.phone,
									type: 0
								}
								// this.$api.SendPhoneCode(phoneParam).then(res => {
								// 	if (res.code == 200) {
		
								// 	}
								// })
							},
							handleSubmit(name) {
		
								this.$refs[name].validate((valid) => {
									if (valid) {
										this.$Message.success('Success!');
									} else {
										this.$Message.error('Fail!');
									}
								})
							},
		
						}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}
	
	.page-account {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		overflow: auto;
	
	}
	
	.page-account-container {
		width: 400px;
		padding: 0 30px 0 10px;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
		border-color: #eee;
	}
	
	.page-account-top .ivu-btn {
		position: absolute;
		margin-left: 20px;
	}
	
	.page-account-top .ivu-btn:focus {
		box-shadow: none;
	}
	
	.page-account-top {
		padding: 30px 0;
	}
	
	
	
	.page-account-top-title {
		display: inline-block;
		width: 100%;
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		color: #45a332;
	}
	
	.page-account-top .text {
		width: 139px;
		height: 16px;
		font-size: 16px;
		font-weight: 500;
		color: #222222;
	}
	
	.page-account-container .phoneCode {
		padding: 0 10px;
		font-size: 14px;
		background-color: #45a332;
		border-color: #45a332;
	}
	
	.page-account-container .phoneCode:hover {
		background-color: #45a332;
		border-color: #45a332;
	}
	
	.login_btn-wrapper {
		margin: 0 0 0 20px;
		text-align: center;
	}
	
	.page-account-container .login_btn.ivu-btn {
		/* width: calc(100% - 0px); */
		/* margin: 10px 0 10px 10px; */
		background-color: #45a332;
		border-color: #45a332;
		color: #fff;
	}
	
	.page-account-container .login_btn.ivu-btn:visited {
		border-color: #45a332;
	}
	
	.page-account-container .login_btn.ivu-btn:hover {
		background-color: #45a332;
		border-color: #45a332;
	}
	
	.page-account-container .login_btn.ivu-btn:focus {
		/* background-color: #5cadff;
		border-color: #5cadff; */
		box-shadow: none;
	}
	
	.ivu-input {
		background-color: #f7f7f7;
		border-color: #f7f7f7;
	}
	
	
	.ivu-input {
		background-color: #f7f7f7;
		border-color: #f7f7f7;
	}
	
	.ivu-btn>.ivu-icon+span,
	.ivu-btn>span+.ivu-icon {
		margin-left: 0;
	}
	
	.ivu-form-item {
		margin-bottom: 32px;
	}
	
	.ivu-form .ivu-form-item-label {
		font-size: 16px;
		font-weight: 500;
		color: #666666;
	}
	
	.ivu-input:hover {
		border-color: #45a332;
	}

</style>